(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/handlebars-helpers.js');

'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('concat', function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return args.slice(0, -1).join('');
  });
}
if (typeof exports === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);